import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { featuredArticles } from '@/mocks/articles';

export default function HotArticlesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100/50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门使用指南
            </h2>
            <p className="text-foreground-600 text-sm">
              最受欢迎的使用教程与攻略文章
            </p>
          </div>
          <Link
            to="/categories"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <ArticleCard
              key={article.slug}
              slug={article.slug}
              title={article.title}
              excerpt={article.excerpt}
              coverImage={article.coverImage}
              categoryName={article.categoryName}
              publishDate={article.publishDate}
              readTime={article.readTime}
              author={article.author}
            />
          ))}
        </div>

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/categories"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}